import { makeStyles } from '@material-ui/core/styles';
import { useBorrowerLoanApplicationsRoutes, useBorrowerLoansStore } from '@roc/feature-borrower-loans';
import { DataGrid, GridColumnProps, LinkColumn, StatusChip, StatusType } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect } from 'react';

export const borrowerLoanApplicationsColumns: GridColumnProps[] = [
  {
    field: 'dealid',
    headerName: 'Loan Id',
    maxWidth: 120,
    cellRenderer: 'loanIdCellRenderer',
  },
  {
    field: 'dealName',
    headerName: 'Deal Name',
    minWidth: 200,
    cellRenderer: 'dealNameCellRenderer',
  },
  {
    field: 'status',
    headerName: 'Status',
    maxWidth: 170,
    cellRenderer: 'statusCellRenderer',
  },
  {
    field: 'loanSubType',
    headerName: 'Loan Type',
    cellRenderer: 'loanSubTypeCellRenderer',
    maxWidth: 300,
  },
  {
    field: 'submissionDate',
    headerName: 'Submission Date',
    maxWidth: 185,
  },
];

export const borrowerLoanApplicationsFrameworkComponents = (borrowerLoanRoutesConfig) => {

  const loanSubTypeCellRenderer = params => {
    const loanSubType = params.node?.data?.loanSubType;
    return (
      <>
        <span>{loanSubType}</span>
      </>
    );
  };

  const loanDetailsLinkCellRenderer = params => {
    const loanId = params.node?.data?.dealid;
    const url = borrowerLoanRoutesConfig.loans(loanId).children.dashboard.url;
    return LinkColumn({ ...params, url });
  };

  return {
    loanIdCellRenderer: loanDetailsLinkCellRenderer,
    dealNameCellRenderer: loanDetailsLinkCellRenderer,
    loanSubTypeCellRenderer: loanSubTypeCellRenderer,
    statusCellRenderer: ({ value }) =>
      value ? (
        <StatusChip statusType={StatusType.LOAN} label={value} size='small' />
      ) : null,
  };
}

const useStyles = makeStyles(theme => ({
  paginationBar: {
    border: 'none',
    borderTop: '1px solid #eee',
    padding: 8,
    background: '#fafafa',
  },
}));

export const BorrowerLoanApplicationsGrid = observer(() => {
  const classes = useStyles();
  const { borrowerLoansStore } = useBorrowerLoansStore();
  const { borrowerLoanApplicationsGridStore } = borrowerLoansStore;
  const gridStore = borrowerLoanApplicationsGridStore;
  const { borrowerLoanApplicationRoutesConfig } = useBorrowerLoanApplicationsRoutes();

  useEffect(() => {
    gridStore.resetAndFetchGridData();
  }, []);

  const onSortChanged = params => {
    const sortModel = params.api.getSortModel();
    gridStore.setSortModel(sortModel);
  };

  return (
    <DataGrid
      columns={borrowerLoanApplicationsColumns}
      rows={gridStore.gridData.data.rows}
      frameworkComponents={borrowerLoanApplicationsFrameworkComponents(borrowerLoanApplicationRoutesConfig)}
      onSortChanged={onSortChanged}
      isLoading={gridStore.isLoading}
      sortModel={gridStore.sortModel}
      filterModel={gridStore.filterModel}
      paginationData={gridStore.gridData.meta}
      paginationBarClassName={classes.paginationBar}
      setPageNumber={gridStore.setPageNumber}
      showPagination={!gridStore.isLoading && gridStore.gridData.meta.totalPages > 1}
      domLayout='autoHeight'
    />
  )
});
